import angular from 'angular';
import DocumentService from '@/shared/services/DocumentService';
import { dynamicSort } from '@/shared/utils/dynamicSort';

angular
  .module('cxSettings')
  .controller('EditMailTemplateSettingsCtrl', [
    '$state',
    '$timeout',
    '$q',
    '$translate',
    'templateHttpSvc',
    'flySvc',
    'dataCache',
    'dialogsSvc',
    'ModalService',
    '$http',
    'appUrls',
    'template',
    'companyId',
    'enumCacheSvc',
    '$filter',
    'checkSecurity',
    'resourceFactorySvc',
    editMailTemplateSettingsCtrl,
  ]);

function editMailTemplateSettingsCtrl(
  $state,
  $timeout,
  $q,
  $translate,
  templateHttpSvc,
  flySvc,
  dataCache,
  dialogsSvc,
  ModalService,
  $http,
  appUrls,
  template,
  companyId,
  enumCacheSvc,
  $filter,
  checkSecurity,
  resourceFactorySvc,
) {
  var vm = this;
  var WORKFLOW_ID_PREFIX = 'workflow-';
  vm.dataCache = dataCache;
  vm.tags = [];
  vm.template = template || {
    autoLinkDocumentTypes: [],
    name: '',
    context: null,
    languages: [],
    companyId: companyId,
    emailBCCType: 0,
    emailBCC: '',
    useGeneralMailSettings: true,
  };
  vm.validation = {};
  vm.settings = {};
  if (vm.template.autoLinkDocumentTypes && vm.template.autoLinkDocumentTypes.length > 0) {
    vm.template.autoLinkDocumentTypes = vm.template.autoLinkDocumentTypes.map(x => ({
      id: x,
      name: $filter('translateList')(x, 'documentType', x),
    }));
  } else {
    vm.template.autoLinkDocumentTypes = [];
  }
  vm.currentPlaceholder = {};
  vm.placeholdersOptions = [];
  vm.groupPlaceholders = null;

  var retrieveDocumentTags = function() {
    $http
      .get(appUrls.documents + '/api/tag')
      .then(function(response) {
        var result = response.data;
        vm.tags = result;
      })
      .catch(function(error) {
        showError(error);
      });
  };

  if (checkSecurity('Settings:u')) {
    retrieveDocumentTags();
  }

  vm.filterTags = function(search) {
    return $filter('filter')(vm.tags, search);
  };

  vm.selectableDocumentTypes = [];

  enumCacheSvc.get('documentType').then(function(data) {
    const unselectableDocumentTypes = [0, 1, 3, 4, 6, 7, 8, 9, 13, 14, 15, 18, 19, 23, -1, 1000];
    vm.selectableDocumentTypes = data
      .filter(x => !unselectableDocumentTypes.some(y => y === x.key))
      .map(x => ({
        id: x.key,
        name: $filter('translateList')(x.key, 'documentType', x.value),
      }));

    vm.selectableDocumentTypes = $filter('orderBy')(vm.selectableDocumentTypes, 'name');
  });

  vm.updateValue = () => {};

  vm.loadSelectableDocumentTypes = function(search) {
    if (vm.selectableDocumentTypes !== null) {
      return $filter('filter')(vm.selectableDocumentTypes, search);
    }
  };

  var retrieveAttachmentsForLanguage = function(lang) {
    return $http
      .get(appUrls.documents + '/api/documents/links/' + lang.id + '/4')
      .then(function(response) {
        var result = response.data;
        vm.attachments[lang.id] = [...(vm.attachments[lang.id] || []), ...result];
        return result;
      })
      .catch(function(error) {
        showError(error);
        return null;
      });
  };
  vm.template.languages
    .filter(x => !!x.id)
    .forEach(lang => {
      if (checkSecurity('Settings:u')) {
        retrieveAttachmentsForLanguage(lang);
      }
      vm.currentPlaceholder[lang.languageCode] = null;
    });

  if (checkSecurity('Settings:u')) {
    resourceFactorySvc
      .get('settings')
      .company({ id: companyId })
      .$promise.then(
        function(result) {
          vm.settings = result;
        },
        function(error) {
          flySvc.error(error.data.code);
          vm.settings = {};
        },
      );
  }

  vm.missingWorkflowConfigs = {};

  if (vm.template.id) {
    $http.get(appUrls.api + '/api/workflowConfiguration').then(function(response) {
      var configIds = response.data.map(c => c.id);

      vm.template.languages.forEach(function(lang) {
        if (lang.content) {
          var content = lang.content.replace(/data:[^"'\s]+/g, '');
          var pattern = new RegExp(
            '<a\\s+id="' + WORKFLOW_ID_PREFIX + '([^"]+)"[^>]*>([^<]*)</a>',
            'g',
          );
          var match;
          var missing = [];
          while ((match = pattern.exec(content)) !== null) {
            if (configIds.indexOf(match[1]) === -1) {
              missing.push({ id: match[1], text: match[2] });
            }
          }
          if (missing.length > 0) {
            vm.missingWorkflowConfigs[lang.languageCode] = missing;
          }
        }
      });
    });
  }

  vm.templateContextChanged = function() {
    vm.taskParameterPlaceholders = [];
    if (vm.template.context === 11 && checkSecurity('Settings:u')) {
      $http.get(`${appUrls.tasks}/api/taskparameters/placeholders`).then(
        function({ data }) {
          vm.taskParameterPlaceholders = data;
          vm.generatePlaceholdersForTypeahead();
        },
        function(error) {
          console.error(error);
        },
      );
    } else {
      vm.generatePlaceholdersForTypeahead();
    }
  };

  vm.taskParameterPlaceholders = [];

  vm.translation = {};
  vm.collapsed = [];
  vm.languages = dataCache.getArray('language');
  vm.companies = dataCache.getAllCompanies();

  vm.saving = false;
  vm.placeholders = {};
  templateHttpSvc.getPlaceholders().then(function(data) {
    vm.placeholders = data;
    vm.generatePlaceholdersForTypeahead();
  });

  var showError = function(error) {
    flySvc.error(error.data.code, error.data.parameters);
  };

  vm.toggleOpen = function(lang) {
    vm.collapsed[lang.languageCode] = !vm.collapsed[lang.languageCode];
  };

  vm.gotoList = function() {
    if (vm.form && vm.form.$dirty) {
      vm.form.$rollbackViewValue();
      vm.form.$setPristine();
    }
    $state.go('settings.interactiontemplates', {
      companyId: companyId,
    });
  };
  vm.isValid = function() {
    if (!vm.template || !vm.form.$valid) return false;
    // for (var i = 0; i < vm.template.languages.length; i++) {
    //   var lang = vm.template.languages[i];
    //   if (!vm.templateForm['lang_' + lang.languageCode].$valid) return false;
    // }

    if (vm.template.context === 15 && !vm.template.companyId) return false;

    return true;
  };
  var sortLanguages = function() {
    if (!vm.template || !vm.template.languages) return;
    var currentLang = $translate.use().split('-')[0];
    vm.template.languages.sort(function(a, b) {
      if (a.languageCode === currentLang) return -1;
      if (b.languageCode === currentLang) return 1;
      if (a.languageCode < b.languageCode) return -1;
      if (a.languageCode > b.languageCode) return 1;
      return 0;
    });
  };
  sortLanguages();

  vm.removeLanguage = function(lang) {
    var idx = vm.template.languages.indexOf(lang);
    if (idx < 0) return;
    dialogsSvc.showYesNo('comfirmDeleteTitle', 'comfirmDeleteTranslation').then(function() {
      if (vm.template.id && !lang.isNew)
        templateHttpSvc.removeLanguage(vm.template.id, lang.languageCode).then(function() {
          vm.template.languages.splice(idx, 1);
        });
      else vm.template.languages.splice(idx, 1);
    });
  };

  var saveLanguages = function() {
    if (!vm.template.id) return $q.reject();
    return $q.all(
      vm.template.languages
        // .filter(function(lang) {
        //   return vm.form['lang_' + lang.languageCode].$dirty;
        // })
        .map(function(lang) {
          return !lang.isNew
            ? templateHttpSvc.updateLanguage(vm.template.id, lang)
            : templateHttpSvc.createLanguage(vm.template.id, lang);
        }),
    );
  };

  let mapValidationError = x => {
    let message = $filter('translateList')(
      x.type,
      'templatevalidationwarningtype',
      x.type,
      x.parameters,
    );
    if (!!x.taskName) {
      if (!!x.subTaskName) {
        return (
          $translate.instant('TaskTemplate') +
          ' ' +
          x.taskName +
          '/' +
          x.subTaskName +
          ' ' +
          message
        );
      }
      return $translate.instant('TaskTemplate') + ' ' + x.taskName + ' ' + message;
    }
    return message;
  };

  var validateLanguages = function() {
    if (!vm.template.id) return $q.reject();
    return $q.all(
      vm.template.languages.map(lang =>
        templateHttpSvc.validateLanguage(vm.template.id, lang).then(
          data => {
            if (!data || data.length === 0) {
              delete vm.validation[lang.languageCode];
            } else {
              vm.validation[lang.languageCode] = data.map(x => mapValidationError(x)).join('\n');
            }
          },
          error => {
            flySvc.error(error);
          },
        ),
      ),
    );
  };

  var saveTranslations = function() {
    if (!vm.translation || !vm.translation.save) return $q.when();
    return vm.translation.save(vm.template.id);
  };

  vm.validate = (saveFirst = false) => {
    $timeout(function() {
      vm.validating = true;
      if (saveFirst) {
        return vm
          .save(false, false)
          .then(() => {
            return validateLanguages().then(x => {
              if (Object.keys(vm.validation).length) {
                flySvc.error('msgSomeLanguagesContainValidationErrors');
              } else {
                flySvc.success();
              }
            });
          })
          .finally(() => {
            vm.validating = false;
          });
      }

      if (vm.template.id) {
        validateLanguages()
          .then(x => {
            if (Object.keys(vm.validation).length) {
              flySvc.error('msgSomeLanguagesContainValidationErrors');
            } else {
              flySvc.success();
            }
          })
          .finally(() => {
            vm.validating = false;
          });
      }
    }, 0);
  };

  vm.save = function(navigateAway = true, showSuccess = true) {
    var deferred = $q.defer();

    $timeout(function() {
      if (!vm.isValid() || vm.saving) return deferred.reject();
      if (vm.translation && !vm.translation.isValid(true)) return deferred.reject();
      vm.saving = true;
      if (vm.template.id) {
        $q.all([saveLanguages(), saveTranslations()])
          .then(function() {
            // if (vm.form.template.$dirty) {
            const model = {
              ...vm.template,
              documentTags: vm.template.documentTags ? vm.template.documentTags.map(x => x.id) : [],
              autoLinkDocumentTypes: vm.template.autoLinkDocumentTypes
                ? vm.template.autoLinkDocumentTypes.map(x => x.id)
                : [],
            };
            return templateHttpSvc.updateTemplate(model);
            //}
            return $q.resolve();
          })
          .then(
            function() {
              vm.saving = false;
              deferred.resolve();
              if (showSuccess) flySvc.success();
              if (navigateAway) vm.gotoList();
            },
            function(errors) {
              flySvc.error(errors);
              //todo: check error response

              deferred.reject();
              vm.saving = false;
            },
          );
      } else {
        const model = {
          ...vm.template,
          documentTags: vm.template.documentTags ? vm.template.documentTags.map(x => x.id) : [],
          autoLinkDocumentTypes: vm.template.autoLinkDocumentTypes
            ? vm.template.autoLinkDocumentTypes.map(x => x.id)
            : [],
        };
        templateHttpSvc.createTemplate(vm.template.companyId, model).then(
          function(template) {
            vm.template.id = template.id;
            $q.all([saveLanguages(), saveTranslations()]).then(
              function() {
                vm.template.languages.forEach(x => (x.isNew = false));
                template.languages = vm.template.languages;
                vm.saving = false;
                deferred.resolve();
                if (showSuccess) flySvc.success();
                if (navigateAway) vm.gotoList();
              },
              function(errors) {
                //todo: check error response
                deferred.reject();
                vm.saving = false;
              },
            );
          },
          function(error) {
            deferred.reject();
            showError(error);
            vm.saving = false;
          },
        );
      }
    }, 0);

    return deferred.promise;
  };
  vm.addLanguage = function(langCode) {
    if (!langCode) return;
    vm.template.languages.push({
      languageCode: langCode,
      content: '',
      title: '',
      isNew: true,
    });

    vm.currentPlaceholder[langCode] = null;
    sortLanguages();
  };

  vm.filterLanguages = function(lang) {
    if (vm.template == null) return true;
    for (var i = 0; i < vm.template.languages.length; i++)
      if (vm.template.languages[i].languageCode === lang.code) return false;
    return true;
  };

  vm.showPlaceholders = function() {
    if (!vm.template.context && vm.template.context !== 0) return;
    if (!vm.placeholders[vm.template.context]) return;

    ModalService.showModal({
      template: require('./dialogs/placeholderDialog.html'),
      controller: 'PlaceholderDialogCtrl',
      controllerAs: 'vm',
      locationChangeSuccess: false,
      inputs: {
        placeholders: vm.placeholders[vm.template.context],
        taskParameterPlaceholders: vm.taskParameterPlaceholders,
        context: 'email',
      },
    }).then(function(modal) {
      modal.element.modal();
      modal.element.on('hidden.bs.modal', function(e) {
        modal.element.off(e); //Remove event
        modal.element.remove(); //Remove element
      });
    });
  };
  vm.generatePlaceholdersForTypeahead = function() {
    if (
      (!vm.template.context && vm.template.context !== 0) ||
      !vm.placeholders[vm.template.context]
    ) {
      vm.placeholdersOptions = [];
      return;
    }

    const normalPlaceholders = vm.placeholders[vm.template.context].map(x => ({
      id: x,
      label: `${x} - ${$filter('translateList')(x, 'mailplaceholder', x)}`,
    }));
    if (!vm.taskParameterPlaceholders) {
      vm.placeholdersOptions = normalPlaceholders;
    } else {
      const taskPlaceholders = vm.taskParameterPlaceholders.flatMap(x => {
        if (!x.placeholders) return [];
        const taskName = $filter('translateList')(
          x.taskTemplateId,
          'taskTemplate',
          x.taskTemplateName,
        );
        if (!taskName) {
          return x.placeholders.map(p => ({ id: p, label: p }));
        }
        return x.placeholders.map(p => ({ id: p, label: `${p} - ${taskName}` }));
      });

      vm.placeholdersOptions = [...normalPlaceholders, ...taskPlaceholders];
    }
  };

  vm.showInsertWorkflowAction = function(langCode) {
    ModalService.showModal({
      template: require('./dialogs/insertWorkflowActionDialog.html'),
      controller: 'InsertWorkflowActionDialogCtrl',
      controllerAs: 'vm',
      locationChangeSuccess: false,
    }).then(function(modal) {
      modal.element.modal();
      modal.close.then(function(result) {
        if (result) {
          var editor = CKEDITOR.instances['content_' + langCode];
          if (editor) {
            var escapedName = result.buttonText
              .replace(/&/g, '&amp;')
              .replace(/</g, '&lt;')
              .replace(/>/g, '&gt;')
              .replace(/"/g, '&quot;');
            editor.insertHtml(
              '<a id="' +
                WORKFLOW_ID_PREFIX +
                result.config.id +
                '" style="' +
                'display: inline-block;' +
                'cursor: pointer;' +
                'padding: 6px 12px;' +
                'background-color: ' +
                result.color +
                ';' +
                'color: #ffffff;' +
                'text-decoration: none;' +
                'border-radius: 4px;' +
                '">' +
                escapedName +
                '</a>',
            );
          }
        }
      });
      modal.element.on('hidden.bs.modal', function(e) {
        modal.element.off(e);
        modal.element.remove();
      });
    });
  };
  vm.insertPlaceholder = function(langCode, item) {
    if (!item || !item.id) return;
    var editor = CKEDITOR.instances['content_' + langCode];
    if (editor) {
      var escapedTag = item.id
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
      editor.insertHtml(escapedTag);
    }
    vm.currentPlaceholder[langCode] = null;
  };
  vm.insertGroupPlaceholder = function(langCode) {
    if (!vm.template.context && vm.template.context !== 0) return;
    if (!vm.groupPlaceholders) {
      return templateHttpSvc.getGroupPlaceholders().then(
        function(data) {
          var raw = data || {};
          vm.groupPlaceholders = Object.keys(raw).reduce(function(acc, contextKey) {
            var groupsObj = raw[contextKey] || {};
            acc[contextKey] = Object.keys(groupsObj)
              .map(function(groupName) {
                return {
                  groupName: groupName,
                  label: $filter('translateList')(groupName, 'mailplaceholdergroup', groupName),
                  placeholders: (groupsObj[groupName] || []).map(function(p) {
                    const translation =
                      $filter('translateList')(p, 'mailgroupplaceholder') ||
                      $filter('translateList')(p, 'mailplaceholder', '');
                    return { placeholder: p, label: translation ? `${p} - ${translation}` : p };
                  }),
                };
              })
              .sort(dynamicSort('label'));
            return acc;
          }, {});
          return vm.insertGroupPlaceholder(langCode);
        },
        error => {
          showError(error);
          vm.groupPlaceholders = {};
        },
      );
    }
    if (!vm.groupPlaceholders[vm.template.context]) return;
    return ModalService.showModal({
      template: require('./dialogs/insertGroupPlaceholderDialog.html'),
      controller: 'InsertGroupPlaceholderDialogCtrl',
      controllerAs: 'vm',
      inputs: {
        groupPlaceholders: vm.groupPlaceholders[vm.template.context],
      },
      locationChangeSuccess: false,
    }).then(function(modal) {
      modal.element.modal();
      modal.close.then(function(result) {
        if (result) {
          var editor = CKEDITOR.instances['content_' + langCode];
          if (editor) {
            editor.insertHtml(result);
          }
        }
      });
      modal.element.on('hidden.bs.modal', function(e) {
        modal.element.off(e);
        modal.element.remove();
      });
    });
  };
  vm.updateName = function(value) {
    vm.template.name = value;
  };

  vm.attachments = {};

  vm.downloadAttachment = function(attachment) {
    DocumentService.download(attachment.id);
  };
  vm.uploadAttachment = function(files, lang) {
    if (!files || files.length < 1 || !lang || !lang.id) return;

    var formData = new FormData();
    formData.append('documentType', 7);
    formData.append('documentLinkType', 4);
    formData.append('linkId', lang.id);
    files.forEach(file => formData.append('data', file.data));

    $http({
      method: 'POST',
      url: appUrls.documents + '/api/documents/',
      headers: {
        'Content-Type': undefined,
      },
      data: formData,
    })
      .then(function(response) {
        var result = response.data;
        if (result && result.length > 0) {
          result.forEach(function(file) {
            vm.attachments[lang.id] = [...(vm.attachments[lang.id] || []), file];
          });
        }
      })
      .catch(function(error) {
        flySvc.error(error.code, error.parameters, null, error.type);
        return '';
      });
  };
  vm.deleteAttachment = function(attachment, lang) {
    dialogsSvc.showYesNo('comfirmDeleteTitle', 'confirmDeleteAttachment').then(function() {
      $http
        .delete(
          `${appUrls.documents}/api/Documents/Links/${attachment.id}/${lang.id}/4?deletedocument=false`,
        )
        .then(function(response) {
          var result = response.data;
          var index = vm.attachments[lang.id].indexOf(attachment);
          if (index >= 0) {
            vm.attachments[lang.id].splice(index, 1);
          }
        })
        .catch(function(error) {
          flySvc.error(error.code, error.parameters);
          return '';
        });
    });
  };

  if (vm.template.context) {
    // retrieve task placeholders if needed
    vm.templateContextChanged();
  }
}
